// One random id per browser tab, kept in sessionStorage (not localStorage)
// on purpose: localStorage is shared across every tab of the same origin,
// so two tabs open on the same computer would look like the same
// "visitor" to the reaction system — exactly what let one tab's unreact
// cancel out a different tab's like on the same card. sessionStorage keeps
// each tab independent while still surviving a reload of that same tab.
const VISITOR_KEY = 'retro-visitor-id'

export const getVisitorId = () => {
  let id = sessionStorage.getItem(VISITOR_KEY)
  if (!id) {
    id = window.crypto.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random()}`
    sessionStorage.setItem(VISITOR_KEY, id)
  }
  return id
}
